let tabsLink = document.querySelectorAll('.tab_link');

tabsLink.forEach(element => element.addEventListener('click', event => {
    event.preventDefault();
    document.querySelector('.tab_link.active').classList.remove('active');
    document.querySelector('.tab_content.active').classList.remove('active');
    element.classList.add('active');
    let id = element.getAttribute('href').replace('#', '');
    document.getElementById(id).classList.add('active')
}));

document.querySelector('.section_sidebar_faq--title_btn').addEventListener('click', function(event){

    event.preventDefault();

    var container = document.querySelector('.section_sidebar_faq__links');

    if (!container.classList.contains('active')) {
      
      this.classList.add('active');
      container.classList.add('active');
      container.style.height = 'auto';

      var height = container.clientHeight + 'px';

      container.style.height = '0px';

      setTimeout(function () {
        container.style.height = height;
      }, 0);
      
    } else {
      
      container.style.height = '0px';
      this.classList.remove('active');
      container.addEventListener('transitionend', function () {
        container.classList.remove('active');
      }, {
        once: true
      });
      
    }
    
  });